import { get,post } from './index';

/**
 * 版权登记API服务
 */

// 获取版权登记主页数据
export const getCopyrightHome = async () => {
  try {
    // 分别调用不同接口获取数据
    const noticeResponse = await get('/notice/list');
    const registerResponse = await get('/register/list');
    
    // 转换返回的数据结构
    const adaptedData = {
      functionButtons: [
        {
          id: "online-registration",
          title: "广西版权网上登记",
          url: "https://whbqgw.yjygx.com/home",
          icon: "📝",
          isExternal: true,
          description: "进入广西版权登记系统进行在线登记"
        },
        {
          id: "copyright-query",
          title: "版权查询",
          url: "https://whbqgw.yjygx.com/regPub/search",
          icon: "🔍",
          isExternal: true,
          description: "查询版权登记信息和状态"
        },
        {
          id: "registration-process",
          title: "登记流程",
          url: "https://whbqgw.yjygx.com/detail?type=REGIST_PROCESS",
          icon: "📋",
          isExternal: true,
          description: "了解版权登记的详细流程"
        },
        {
          id: "registration-guide",
          title: "登记须知",
          url: "https://whbqgw.yjygx.com/detail?type=REGIST_NOTIFY",
          icon: "📖",
          isExternal: true,
          description: "版权登记的注意事项和指南"
        }
      ],
      recentAnnouncements: noticeResponse.records.map(record => ({
        id: record.noticeId,
        noticeId: record.noticeId, // 保留原始noticeId
        i18nInfo: record.i18nInfo, // 保留完整的i18nInfo数组
        publishDate: record.publishTime ? new Date(record.publishTime).toISOString() : new Date().toISOString()
      })),
      featuredProducts: registerResponse.records.map(record => ({
        id: record.registerId,
        title: record.workName,
        coverId: record.coverId,
        author: record.owner,
        phone: record.phone,
        content: record.workDesc,
        registrationDate: new Date().toISOString()
      }))
    };
    
    return adaptedData;
  } catch (error) {
    console.error('❌ 获取版权登记主页数据失败:', error);
    throw error;
  }
};

// 获取登记公示列表
export const getAnnouncementList = async (params = {}) => {
  const response = await get('/notice/list', params);
  
  // 转换返回的数据结构
  const adaptedData = {
    announcements: response.records.map(record => ({
      id: record.noticeId,
      noticeId: record.noticeId, // 保留原始noticeId
      i18nInfo: record.i18nInfo, // 保留完整的i18nInfo数组
      publishDate: record.publishTime ? new Date(record.publishTime).toISOString() : new Date().toISOString(),
      noticeUrl: record.noticeUrl
    })),
    pagination: {
      currentPage: response.current || 1,
      totalPages: response.pages || 1,
      totalCount: response.total || 0,
      pageSize: response.size || 10
    }
  };
  
  return adaptedData;
};

// 获取登记公示详情
export const getAnnouncementDetail = async (id) => {
  try {
    const response = await get(`/notice/getById?noticeId=${id}`);
    
    // 直接返回接口返回的内容，不进行转换
    return response;
  } catch (error) {
    console.error('❌ 获取登记公示详情失败:', error);
    throw error;
  }
};

// 获取已登记产品列表
export const getRegistrationProductList = async (params = {}) => {
  try {
    // 调用实际API
    const response = await get('/register/list', params);
    
    // 转换返回的数据结构
    const adaptedData = {
      products: response.records.map(record => ({
        id: record.registerId,
        title: record.workName,
        coverId: record.coverId,
        author: record.owner,
        phone: record.phone,
        content: record.workDesc,
        registrationDate: new Date().toISOString()
      })),
      pagination: {
        currentPage: response.current || 1,
        totalPages: response.pages || 1,
        totalCount: response.total || 0,
        pageSize: response.size || 10
      }
    };
    
    return adaptedData;
  } catch (error) {
    console.error('❌ 获取已登记产品列表失败:', error);
    throw error;
  }
};

// 获取已登记产品详情
export const getRegistryInfoById = (id) => {
  return get(`/register/getRegisterInfoById?registerId=${id}`);
};

// 下载公示PDF
export const downloadAnnouncementPDF = (id) => {
  return get(`/copyright/announcements/${id}/download`, {
    responseType: 'blob'
  });
};

// 记录外部链接点击
export const trackExternalLinkClick = (data) => {
  return post('/copyright/track/external-link', data);
}; 